module.exports = __webpack_public_path__ + "static/media/email-sent.63b294ab.svg";